export default {

  todaysWins(context, data) {
    context.commit('todaysWins', data);
  },

  todaysBigTask(context, data) {
    context.commit('todaysBigTask', data);
  },

  todaysSmallTasks(context, data) {
    context.commit('todaysSmallTasks', data);
  },

};
